"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
const PartSteper = _ref => {
  let {
    steperComponent,
    stepCount,
    loadingFlag,
    Loader
  } = _ref;
  return loadingFlag ? /*#__PURE__*/_react.default.createElement("div", null, Loader) : steperComponent.length > 0 && steperComponent[stepCount];
};
var _default = exports.default = PartSteper;